import React from 'react';
import ListItem from '../../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../../elements/ListItem/ListItemContent';
import TimeSpan from '../../../../elements/TimeSpan/TimeSpan';
import styles from './Task.module.scss';
import HandIcon from '../../../../../resources/icons/hand-regular.svg';
import Icon from '../../../../elements/icons/Icon';
import Location from '../../../../elements/Location';

function Task(props) {
    const { event, task, className = '', style } = props;

    return (
        <ListItem
            tagName="div"
            className={[styles.Task].join(' ')}
            style={{
                backgroundColor: task.block_color,
            }}>
            <HandIcon className={styles.taskIcon} />
            <TimeSpan className="ProgramListItem--time" start={task.start_local} end={task.end_local} />
            <ListItemContent href={['.', task.id].join('/')}>
                <p className="text name large">
                    <strong>{task.name}</strong>
                </p>
                {task.location ? <Location className={styles.location}>{task.location}</Location> : null}
            </ListItemContent>
        </ListItem>
    );
}

export default Task;
